import _ from "lodash/fp";
import {combineActions, handleActions} from "redux-actions";
import {createMessage} from "../messages/createMessage";
import {dismissMessage} from "../messages/dismissMessage";
import {createSigntask} from "../signtasks/createSigntask";
import {deactivateSigntask} from "../signtasks/deactivateSigntask";
import {fetchSigntask} from "../signtasks/fetchSigntask";
import {fetchSigntasks} from "../signtasks/fetchSigntasks";
import {fetchOrderStatus} from "../signtasks/fetchOrderStatus";
import {createTemplate} from "../templates/createTemplate";

export default handleActions(
  {
    [createMessage]: (state, {payload}) => [...state, payload],
    [createSigntask.success]: (state, {payload}) =>
      [...state, ..._.map(signtask => ({style: "success", lines: [`Signeringsoppdrag opprettet.`]}), payload)],
    [createTemplate.success]: (state, {payload}) =>
      [...state, ..._.map(template => ({style: "success", lines: [`Created template with name ${template.name}`]}), payload)],
    [combineActions(
      createSigntask.failure,
      deactivateSigntask.failure,
      fetchSigntask.failure,
      fetchSigntasks.failure,
      fetchOrderStatus.failure,
      createTemplate.failure)]: (state, {payload}) =>
      [...state, ..._.map(error => ({style: "danger", lines: error}), payload)],
    [dismissMessage]: (state, {payload}) =>
      [..._.take(payload, state), ..._.drop(payload + 1, state)]
  },
  []
)
